// extracted by mini-css-extract-plugin
export default {"bottomSection":"styles_bottomSection__1mH2z","sectionName":"styles_sectionName__H-JXY","areaItem":"styles_areaItem__PPOk3"};